var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTagToClient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.465,11.69,11.082,1.321A4.5,4.5,0,0,0,9.6.385,4.486,4.486,0,0,0,7.9,0H1.861A1.787,1.787,0,0,0,.554.552,1.786,1.786,0,0,0,0,1.859V7.9A4.483,4.483,0,0,0,.387,9.6a4.327,4.327,0,0,0,.937,1.467l10.383,10.4A1.778,1.778,0,0,0,13.013,22a1.86,1.86,0,0,0,1.321-.537l7.13-7.145A1.779,1.779,0,0,0,22,13.011,1.861,1.861,0,0,0,21.465,11.69ZM5.963,5.961a1.791,1.791,0,0,1-1.314.545A1.859,1.859,0,0,1,2.79,4.647,1.859,1.859,0,0,1,4.649,2.788,1.859,1.859,0,0,1,6.508,4.647,1.79,1.79,0,0,1,5.963,5.961Z",
    transform: "translate(-0.002)",
    fill: "#c6c9d8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagToClient);
export default __webpack_public_path__ + "static/media/tag-to-client.54e875a5a2a7f446d0e491c028688316.svg";
export { ForwardRef as ReactComponent };